import { render, staticRenderFns } from "./SubmitRecord3List.vue?vue&type=template&id=b3f4d6e6&scoped=true&"
import script from "./SubmitRecord3List.vue?vue&type=script&lang=ts&"
export * from "./SubmitRecord3List.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitRecord3List.vue?vue&type=style&index=0&id=b3f4d6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f4d6e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
